import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput,DateField,BooleanField
 }
from 'admin-on-rest/lib/mui';

export const BitulimList = (props) => (
    <List perPage={30} title="ביטולים" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
            
            
            <TextField label="ח. אשראי" source="cc_company"/>
            <TextField label="בית עסק" source="buisiness_id"/>
            <TextField label="כ.אשראי" source="cc_id"/>
            <DateField label="ת. תנועה" source="tnua_date.date" locales="he-IL"/>
            
            <TextField label="ברוטו" source="bruto"/>
            <TextField label="נטו" source="neto"/>
            <TextField label="עמלה" source="amla"/>
            <TextField label="מעמ עמלה" source="vat_amla"/>
            <TextField label="סוג תנועה" source="sug_tnua"/>
            
            <DateField label="ת . חיוב זיכוי" source="hiyuv_zikuy_date.date" locales="he-IL"/>
            
            <TextField label="מטבע" source="currency"/>
            
            <BooleanField label="אינדיקציה הכחשה" source="hachhasha_indication"/>
            <TextField label="מזהה תנועה" source="mezahe_tnua"/>
            <TextField label="source_file" source="source_file"/>
            

            <ShowButton />
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span> {record ? `${record.id}` : ''}</span>;
};


export const BitulimShow = (props) => (

<Show title={<PostTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
            
        <TextField label="מזהה רשת" source="external_id"/>
            <TextField label="ח. אשראי" source="cc_company"/>
            <TextField label="בית עסק" source="buisiness_id"/>
            <TextField label="כ.אשראי" source="cc_id"/>
            <DateField label="ת. תנועה" source="tnua_date.date" locales="he-IL"/>
            <DateField label="ת. הפקדה" source="hafkada_date.date" locales="he-IL"/>
            <TextField label="ברוטו" source="bruto"/>
            <TextField label="נטו" source="neto"/>
            <TextField label="עמלה" source="amla"/>
            <TextField label="מעמ עמלה" source="vat_amla"/>
            <TextField label="סוג תנועה" source="sug_tnua"/>
            <TextField label="מס ריכוז" source="mispar_rikuz"/>
            <DateField label="ת . חיוב זיכוי" source="hiyuv_zikuy_date.date" locales="he-IL"/>
            <TextField label="תיק ארוע" source="tik_erua"/>
            <TextField label="מטבע" source="currency"/>
            <TextField label="מטבע חיוב זיכוי" source="hiyuv_zikuy_currency"/>
            <TextField label="סוג תיק ארוע" source="sug_tik_erua"/>
            <TextField label="תיאור תיק ארוע" source="description_tik_erua"/>
            <TextField label="מס. איחזור" source="mispar_ichzur"/>
            <BooleanField label="אינדיקציה הכחשה" source="hachhasha_indication"/>
            <TextField label="מזהה תנועה" source="mezahe_tnua"/>
            <TextField label="מזהה GTW" source="mezahe_GTW"/>
            <TextField label="ARN" source="arn"/>

            

         </SimpleShowLayout>
    </Show>
);

       
         





              



// WEBPACK FOOTER //
// ./src/components/Bitulim/bitulim.js